import {
  serializeMainGenreValue,
  deserializeMainGenreValue,
  serializeSubGenreValue,
  deserializeSubGenreValue,
  serializeSelectedGameValue,
  deserializeSelectedGameValue,
} from './utils';

export type TUrlQueryKey =
  | 'my_filter'
  | 'date_type'
  | 'start_date'
  | 'end_date'
  | 'markets'
  | 'regions'
  | 'region_type'
  | 'genre_source'
  | 'genre_main_genres'
  | 'genre_sub_genres'
  | 'filter_ids'
  | 'search_keywords'
  | 'search_all'
  | 'checked_list'
  | 'digital_segments'
  | 'companies'
  | 'publisher_classes'
  | 'publisher_regions'
  | 'developers'
  | 'steam_tags'
  | 'steam_tags_logic'
  | 'game_modes'
  | 'digital_min'
  | 'digital_max'
  | 'pcu_min'
  | 'pcu_max'
  | 'wishlists_min'
  | 'wishlists_max'
  | 'physical_min'
  | 'physical_max'
  | 'price_min'
  | 'price_max'
  | 'premium_min'
  | 'premium_max'
  | 'release_type'
  | 'release_start'
  | 'release_end'
  | 'devices'
  | 'pc_console_metrics'
  | 'platform_map'
  | 'publisher';

export const FILTER_URL_CONFIG: Record<TUrlQueryKey, IFilterUrlConfigItem<TUrlQueryKey>> = {
  my_filter: {
    inputPath: 'myFilter/value',
    input: 'string',
  },
  date_type: {
    inputPath: 'rangeTime/type',
    input: 'string',
  },
  start_date: {
    inputPath: 'rangeTime/value/0',
    input: 'startDate',
    defaultGranularity: 'week',
    outputConditionKey: 'date_type',
  },
  end_date: {
    inputPath: 'rangeTime/value/1',
    input: 'endDate',
    defaultGranularity: 'week',
    outputConditionKey: 'date_type',
  },
  markets: {
    inputPath: 'region/markets',
    input: 'array',
  },
  regions: {
    inputPath: 'region/regions',
    input: 'array',
  },
  region_type: {
    inputPath: 'region/type',
    input: 'string',
  },
  genre_source: {
    inputPath: 'genretor/source',
    input: 'string',
  },
  genre_main_genres: {
    inputPath: 'genretor/mainGenres',
    input: 'objectArray',
    // @ts-ignore
    serializeValue: serializeMainGenreValue,
    deserializeValue: deserializeMainGenreValue,
  },
  genre_sub_genres: {
    inputPath: 'genretor/subGenres',
    input: 'objectArray',
    // @ts-ignore
    serializeValue: serializeSubGenreValue,
    deserializeValue: deserializeSubGenreValue,
  },
  filter_ids: {
    inputPath: 'allGames/value',
    input: 'array',
  },
  search_keywords: {
    inputPath: 'allGames/keywords',
    input: 'string',
  },
  search_all: {
    inputPath: 'allGames/isSearchAll',
    input: 'boolean',
  },
  checked_list: {
    inputPath: 'allGames/checkedList',
    input: 'objectArray',
    // @ts-ignore
    serializeValue: serializeSelectedGameValue,
    deserializeValue: deserializeSelectedGameValue,
  },
  digital_segments: {
    inputPath: 'digital_segment_multiple/value',
    input: 'array',
  },
  companies: {
    inputPath: 'publisher_company/value',
    input: 'array',
  },
  publisher_classes: {
    inputPath: 'publisher_class/value',
    input: 'array',
  },
  publisher_regions: {
    inputPath: 'publisher_region/markets',
    input: 'array',
  },
  developers: {
    inputPath: 'developer/value',
    input: 'array',
  },
  steam_tags: {
    inputPath: 'steam_tag/value',
    input: 'array',
  },
  steam_tags_logic: {
    inputPath: 'steam_tag/logic',
    input: 'string',
  },
  game_modes: {
    inputPath: 'game_mode/value',
    input: 'array',
  },
  digital_min: {
    inputPath: 'digital_range/value/min',
    input: 'string',
  },
  digital_max: {
    inputPath: 'digital_range/value/max',
    input: 'string',
  },
  pcu_min: {
    inputPath: 'pcu_range/value/min',
    input: 'string',
  },
  pcu_max: {
    inputPath: 'pcu_range/value/max',
    input: 'string',
  },
  wishlists_min: {
    inputPath: 'wishlists_range/value/min',
    input: 'string',
  },
  wishlists_max: {
    inputPath: 'wishlists_range/value/max',
    input: 'string',
  },
  physical_min: {
    inputPath: 'physical_range/value/min',
    input: 'string',
  },
  physical_max: {
    inputPath: 'physical_range/value/max',
    input: 'string',
  },
  price_min: {
    inputPath: 'price_range/value/min',
    input: 'string',
  },
  price_max: {
    inputPath: 'price_range/value/max',
    input: 'string',
  },
  premium_min: {
    inputPath: 'premium_range/value/min',
    input: 'string',
  },
  premium_max: {
    inputPath: 'premium_range/value/max',
    input: 'string',
  },
  release_type: {
    inputPath: 'releaseTime/type',
    input: 'string',
  },
  release_start: {
    inputPath: 'releaseTime/value/0',
    input: 'startDate',
    defaultGranularity: 'date',
    outputConditionKey: 'release_type',
  },
  release_end: {
    inputPath: 'releaseTime/value/1',
    input: 'endDate',
    defaultGranularity: 'date',
    outputConditionKey: 'release_type',
  },
  devices: {
    inputPath: 'metrictable_device/value',
    input: 'array',
  },
  pc_console_metrics: {
    inputPath: 'pcConsole_topCharts_metrics/value',
    input: 'array',
  },
  platform_map: {
    inputPath: 'platform_cascader/value',
    input: 'oneToManyObject',
  },
  publisher: {
    inputPath: 'publisher/value',
    input: 'string',
  },
};
